import { EVENT_TEAM_CACHE_FIELDS } from '@/client/exchanges/cacheExchange/constants';
import invalidateFields, {
  type FieldInvalidationCache,
} from '@/client/exchanges/cacheExchange/invalidateFields';

export default function insert_event_team_management_one(
  _parent: unknown,
  _args: unknown,
  cache: FieldInvalidationCache,
  _info: unknown,
) {
  invalidateFields(EVENT_TEAM_CACHE_FIELDS, cache);
}
